
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"id\":2,\"omit\":0,\"remove\":true}!css-loader?{\"importLoaders\":2,\"minimize\":true,\"url\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-8c168c5c\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader!sass-loader?{\"includePaths\":[\"scss\"]}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./lowCost2.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./lowCost2.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8c168c5c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./lowCost2.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/includes/components/sliders/lowCost2.vue
// module id = 69
// module chunks = 38